var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex w-screen gap-6 px-6 pt-6" }, [
    _c(
      "div",
      {
        staticClass:
          "relative flex-shrink-0 pb-32 overflow-y-auto border rounded-t bg-pure-white border-slate-400 ",
        style: { height: "calc(100vh - 15.5rem)", width: "19.5rem" },
        attrs: { id: "list-of-targets" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "sticky top-0 z-10 flex flex-col gap-1 px-6 py-5 bg-pure-white"
          },
          [
            _c("BlTextSubtitle1", { attrs: { text: "List of targets" } }),
            _vm._v(" "),
            _c("BlTextBody2", {
              attrs: { text: _vm.selectedTargets.length + " target(s)" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.selectedTargets, function(target) {
          return _c(
            "div",
            {
              key: target.id,
              staticClass:
                "relative flex flex-col h-32 gap-1 px-6 py-4 border cursor-pointer border-slate-400",
              class: { "bg-slate-300": _vm.reviewed.id === target.id },
              on: {
                click: function($event) {
                  return _vm.onSelectReview(target)
                }
              }
            },
            [
              _c("div", {
                staticClass: "absolute left-0 top-0 h-32 w-1.5",
                style: { backgroundColor: target.curriculum_color }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "truncate",
                attrs: {
                  text: target.curriculum_name,
                  title: target.curriculum_name
                }
              }),
              _vm._v(" "),
              _c("BlTextSubtitle3", {
                staticClass: "truncate text-slate-1000",
                attrs: { text: target.name, title: target.name }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "whitespace-pre-line line-clamp-2",
                attrs: { text: target.description, title: target.description }
              })
            ],
            1
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "w-full overflow-hidden bg-pure-white",
        style: { height: "calc(100vh - 15.5rem)" },
        attrs: { id: "review-target" }
      },
      [
        _vm.reviewLoading
          ? _c("div", { staticClass: "grid h-full place-items-center" }, [
              _c("div", { staticClass: "blum-loader" })
            ])
          : _vm.reviewed.id
          ? _c("TargetProperty", {
              staticClass: "w-full m-0 rounded",
              style: { height: "calc(100vh - 13.5rem)" },
              attrs: {
                target: _vm.reviewed,
                graphEntries: _vm.graphEntries,
                entries: _vm.entries,
                readonly: ""
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.reviewLoading
      ? _c(
          "div",
          {
            staticClass: "grid flex-shrink-0 place-items-center",
            style: { height: "calc(100vh - 15.5rem)", width: "19.5rem" }
          },
          [_c("div", { staticClass: "blum-loader" })]
        )
      : _vm.reviewed.id
      ? _c(
          "div",
          {
            staticClass:
              "flex flex-col items-center flex-shrink-0 pb-16 overflow-x-hidden overflow-y-auto",
            style: { height: "calc(100vh - 15.5rem)", width: "19.5rem" },
            attrs: { id: "target-measurement" }
          },
          [
            _c(
              "div",
              { style: { width: "21rem", transform: "scale(0.9)" } },
              [
                _c("MeasurementCard", {
                  staticClass: "min-h-128",
                  style: { height: "100%" },
                  attrs: {
                    measurement: {
                      target_id: _vm.reviewed.id,
                      target: _vm.reviewed,
                      is_fixed: false,
                      is_dropped: false,
                      type: _vm.measurementType,
                      results: _vm.measurementResults
                    },
                    sessionStatus: "completed"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.reviewed.type.includes("Percentage") &&
            _vm.reviewed.probing_enable
              ? _c("div", { staticClass: "mb-4" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-between p-1 mx-auto rounded w-38 bg-slate-400"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "px-2 h-7.5 flex items-center border outline-none",
                          class: [
                            !_vm.probing
                              ? "bg-pure-white border-slate-500 rounded"
                              : "border-slate-400"
                          ],
                          on: {
                            click: function($event) {
                              _vm.probing = false
                            }
                          }
                        },
                        [_c("BlTextSubtitle3", { attrs: { text: "Regular" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "px-2 h-7.5 flex items-center border outline-none",
                          class: [
                            _vm.probing
                              ? "bg-pure-white border-slate-500 rounded"
                              : "border-slate-400"
                          ],
                          on: {
                            click: function($event) {
                              _vm.probing = true
                            }
                          }
                        },
                        [_c("BlTextSubtitle3", { attrs: { text: "Probing" } })],
                        1
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _vm.probing
                  ? _c("BlTextSubtitle3", {
                      staticClass: "text-slate-600",
                      attrs: {
                        text:
                          "This card will be displayed when you opt to conduct probing during the session."
                      }
                    })
                  : _vm.reviewed.probing_enable
                  ? _c("BlTextSubtitle3", {
                      staticClass: "text-slate-600",
                      attrs: {
                        text:
                          "Card preview for sessions without activating probing"
                      }
                    })
                  : _c("BlTextSubtitle3", {
                      staticClass: "text-slate-600",
                      attrs: { text: "Card preview during the session" }
                    })
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-770c1b30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-770c1b30","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/modal/ReviewTargetDatabank.vue
// module id = null
// module chunks = 